import MissingField from '../../filterQueryFormat/MissingField';
import fromDateRefinementFilter from './fromObjectSegFilter/fromDateRefinementFilter';
import fromNumberRefinementFilter from './fromObjectSegFilter/fromNumberRefinementFilter';
import toRefinementFilter from './toObjectSegFilter/toRefinementFilter';
import { DATE_REFINEMENT, NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
export const tryAddMultipleRefinements = (operator, field, filter, hasMultipleRefinements = true) => {
  if (MissingField.isMissingField(field)) {
    return operator;
  }
  const dateRefinement = fromDateRefinementFilter(field, filter);
  const numberRefinement = fromNumberRefinementFilter(field, filter);
  if (!hasMultipleRefinements) {
    if (dateRefinement) {
      return operator.set(DATE_REFINEMENT, dateRefinement);
    }
    if (numberRefinement) {
      return operator.set(NUMBER_REFINEMENT, numberRefinement);
    }
    return operator;
  }
  const refinedOperator = dateRefinement ? operator.set(DATE_REFINEMENT, dateRefinement) : operator;
  return numberRefinement ? refinedOperator.set(NUMBER_REFINEMENT, numberRefinement) : refinedOperator;
};
export const toMultipleRefinementFilter = (operator, hasMultipleRefinements = true) => {
  const dateRefinement = operator.get(DATE_REFINEMENT);
  const numberRefinement = operator.get(NUMBER_REFINEMENT);
  let refinementFilter = {};
  if (dateRefinement) {
    refinementFilter = Object.assign({}, refinementFilter, toRefinementFilter(dateRefinement));
    if (!hasMultipleRefinements) {
      return refinementFilter;
    }
  }
  if (numberRefinement) {
    refinementFilter = Object.assign({}, refinementFilter, toRefinementFilter(numberRefinement));
  }
  return refinementFilter;
};